module.exports = __webpack_public_path__ + "img/bannernotif.d8a73c1c.jpg";